import axios from "axios";
import AppConfig from "../config/app-config";

/**
 * This service is used to send REST calls to the Java server client.
 */
class RestService {
  private http: any;
  private BASE_URL: string = AppConfig.REST_END_POINT;

  /**
   * Create the REST service.
   */
  constructor() {
    console.log('BASE_URL', this.BASE_URL);
    this.http = axios.create({
      baseURL: this.BASE_URL,
      headers: { 'Content-type': 'application/json' },
    });
  }

  /**
   * This is to handle "post" requests.
   * @param url - REST URL
   * @param data - response body
   */
  public post(url: string, data: any) {
    return this.http.post(url, data);
  }

  /**
   * This is to handle "get" requests.
   * @param url - REST URL
   */
  public get(url: string) {
    return this.http.get(url);
  }
}

export default new RestService();
